module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-500.cda5eee7.eot";